export const CONTEXT_NODE_TYPE = {
  DOMAIN: "domain",
  TAG: "tag",
  CUSTOMER: "customer",
};

export const VIRTUAL_CUSTOMER_PARENT = {
  NODE_ID: 0,
  STRING_NODE_ID: "0",
  DEFAULT_LABEL: "Customer",
};
